import {
    DISPATCH_ADMIN_DATA_UPDATE,
    DISPATCH_ADMIN_DATA_UPDATE_SUCCESS,
    DISPATCH_ADMIN_DATA_UPDATE_FAILURE,
} from './constants';
import { clearAdminDataUpdateStatus } from './actions';

const initialState = {
    dispatchAdminUpdate:{
        dispatching: false,
        dispatched: false,
        error: null,
        status: null,
        dispatchAdminDataUpdateEstimatedEndTime: null,
    }
};

const dispatchAdminUpdate = (state = initialState, action) => {
    switch (action.type) {
        case DISPATCH_ADMIN_DATA_UPDATE:
            return {
                ...state,
                dispatchAdminUpdate: { ...state.dispatchAdminUpdate, dispatching: true, dispatched: false, error: null }
            };
        case DISPATCH_ADMIN_DATA_UPDATE_SUCCESS:
            return {
                ...state,
                dispatchAdminUpdate: {
                    status: action.payload.status,
                    dispatching: false,
                    dispatched: true,
                    error: null,
                    dispatchAdminDataUpdateEstimatedEndTime: action.payload.dispatchAdminDataUpdateEstimatedEndTime,
                }
            };
        case DISPATCH_ADMIN_DATA_UPDATE_FAILURE:
            return {
                ...state,
                dispatchAdminUpdate: {
                    ...state.dispatchAdminUpdate,
                    dispatching: false,
                    dispatched: false,
                    error: action.payload.message,
                    dispatchAdminDataUpdateEstimatedEndTime: action.payload.dispatchAdminDataUpdateEstimatedEndTime,
                }
            };
        case clearAdminDataUpdateStatus:
            return {
                ...state,
                dispatchAdminUpdate: {
                    ...state.dispatchAdminUpdate,
                    status: null,
                    dispatched: false,
                }
            };
        default:
            return state;
    }
};

export default dispatchAdminUpdate;
